var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("f7-page", { staticClass: "homepage-wrapper" }, [
    _c(
      "main",
      {
        staticClass: "homepage-main",
        attrs: { id: "homepage-main-content", role: "main", tabindex: "-1" },
      },
      [
        _c(
          "div",
          {
            staticClass: "main-content d-flex flex-column",
            class: _vm.isFirstLoginTrue ? "filter-blur-20px" : "",
          },
          [
            _c(
              "div",
              { staticClass: "content-wrapper flex-grow-1 d-flex" },
              [
                _c("h1", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("Webheader.homepage"))),
                ]),
                _vm._v(" "),
                _c(
                  "b-container",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center main-page-positionning",
                    class: { "w-60": _vm.getCols < 5 },
                  },
                  [
                    _c(
                      "b-row",
                      { attrs: { "align-h": "start", cols: _vm.getCols } },
                      _vm._l(_vm.data, function (action, index) {
                        return _c(
                          "b-col",
                          { key: action.id },
                          [
                            _c(
                              "b-container",
                              {
                                staticClass: "homeButton",
                                class: _vm.getColor(index),
                                attrs: {
                                  fluid: "",
                                  role: "button",
                                  tabindex: "0",
                                  "aria-label": _vm.$t(action.title),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.redirect(action.link)
                                  },
                                  keydown: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.redirect(action.link)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "space",
                                          32,
                                          $event.key,
                                          [" ", "Spacebar"]
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.redirect(action.link)
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "blocHome" },
                                  [
                                    _c("b-col", { attrs: { cols: "9" } }, [
                                      _c("i", {
                                        staticClass: "homeButtonIcon fa",
                                        class: action.icon,
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "d-flex-end h-50" },
                                  [
                                    _c("b-col", { attrs: { cols: "9" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-100 fs-19px font-weight-bold text-white",
                                        },
                                        [_vm._v(_vm._s(_vm.$t(action.title)))]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "footer",
              { staticClass: "homepage-footer pb-10px mt-auto" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticClass: "xs-12 text-center" }, [
                      _c(
                        "div",
                        { staticClass: "d-block d-md-none text-center" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-inline-flex align-items-center justify-content-center flex-wrap mb-2",
                            },
                            [
                              _c("img", {
                                staticClass: "logoStreammind",
                                attrs: {
                                  alt: "Logo Streammind - Retour à la page d'accueil",
                                  src: _vm.logoStreammind,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(_vm._s(_vm.$t("common.copyright"))),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.version))]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center flex-wrap",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-decoration-underline text-muted d-inline-block mx-2",
                                  staticStyle: {
                                    "font-size": "11px",
                                    "white-space": "nowrap",
                                    "line-height": "1.2",
                                  },
                                  attrs: {
                                    href: "/sitemap",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "aria-label":
                                      _vm.$t("footer.sitemap") +
                                      " - " +
                                      _vm.$t("common.opens_new_window"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("footer.sitemap")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-decoration-underline text-muted d-inline-block mx-2",
                                  staticStyle: {
                                    "font-size": "11px",
                                    "white-space": "nowrap",
                                    "line-height": "1.2",
                                  },
                                  attrs: {
                                    href: "/accessibilite",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "aria-label":
                                      _vm.$t(
                                        "footer.accessibility_notice_compliant"
                                      ) +
                                      " - " +
                                      _vm.$t("common.opens_new_window"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "footer.accessibility_notice_compliant"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-md-block position-relative text-center",
                          staticStyle: { "min-height": "1.5rem" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-left",
                              staticStyle: {
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                "max-width": "150px",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-decoration-underline text-muted d-inline-block",
                                  staticStyle: {
                                    "font-size": "11px",
                                    "white-space": "normal",
                                    "word-break": "break-word",
                                    "line-height": "1.2",
                                  },
                                  attrs: {
                                    href: "/sitemap",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "aria-label":
                                      _vm.$t("footer.sitemap") +
                                      " - " +
                                      _vm.$t("common.opens_new_window"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("footer.sitemap")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-inline-flex align-items-center justify-content-center flex-wrap",
                            },
                            [
                              _c("img", {
                                staticClass: "logoStreammind",
                                attrs: {
                                  alt: "Logo Streammind - Retour à la page d'accueil",
                                  src: _vm.logoStreammind,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(_vm._s(_vm.$t("common.copyright"))),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.version))]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "text-right",
                              staticStyle: {
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                "max-width": "150px",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-decoration-underline text-muted d-inline-block",
                                  staticStyle: {
                                    "font-size": "11px",
                                    "white-space": "normal",
                                    "word-break": "break-word",
                                    "line-height": "1.2",
                                  },
                                  attrs: {
                                    href: "/accessibilite",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "aria-label":
                                      _vm.$t(
                                        "footer.accessibility_notice_compliant"
                                      ) +
                                      " - " +
                                      _vm.$t("common.opens_new_window"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "footer.accessibility_notice_compliant"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }